import React, { useEffect, useRef } from 'react';
import ReactEcharts from 'echarts-for-react';
import * as echarts from 'echarts'


export default function HorizontalStackBars({ data, barColor, grid, lineColor, barWidth, legends, yaxis, names }) {



    const MyChart = React.memo(({ options }) => {
        return <ReactEcharts option={options} opts={{ renderer: 'svg' }} notMerge={true} lazyUpdate={true} echarts={echarts} style={{height: '3rem', display:'flex', justifyContent:'center'}}
        />;
    });

    const options = {
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(50,50,50,0.7)',
            borderColor: "#333",
            textStyle: {
                fontSize: 12,
                fontWeight: "normal",
                color: '#fff',
            },
            axisPointer: {
                type: 'shadow'
            },

        },
        legend: {
            show: false,

            orient: 'horizontal',
            top: 0,
            right: -50,

            itemWidth: 12,
            itemHeight: 12
        },
        grid: grid,
        xAxis: {
            type: 'value',
            splitLine: {
                show: false
            }, axisLabel: {
                show: false,
            }
        },
        yAxis: {
            type: 'category',
            data: ['Enrollment'],
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            axisLabel: {
                show: false,

            }
        },
        series: [
            {
                name: names[0],
                type: 'bar',
                // stack: 'total',
                // barWidth: barWidth,
                barWidth: '40',
                barGap:'-85%',
                // barHeight: '10',
                data: data?.value,
                color: "#d46c58",
                label: {
                    show: false,
                    fontSize: 10,
                    formatter: function (params) {
                        return params.data
                    },
                    color: "#09230A"
                },
                itemStyle: {
                    borderRadius: [0, 10, 10, 0]
                },
            },
            {
                name: names[1],
                type: 'bar',
                // stack: 'total',
                barWidth: '20',
                color: "#ea9e50",
                label: {
                    show: false,
                    fontSize: 10,
                    // position: "right",
                    formatter: function (params) {
                        return params.data
                    },
                    color: "#FFFFFF"

                },
                itemStyle: {
                    borderRadius: [0, 10, 10, 0]
                },
                data: data?.value1,

            },

        ]
    };

    return (
        <div  >
            <MyChart options={options} />
        </div>
    );
}


